import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-card-save-actions', standalone: true, imports: [CommonModule, TranslateModule],
  templateUrl: './card-save-actions.component.html', styleUrls: ['./card-save-actions.component.scss']
})
export class CardSaveActionsComponent {
  @Input() dirty = false;
  @Input() saving = false;
  @Input() saved = false;
  @Input() blocked = false;
  @Input() removing = false;
  @Input() errorKey = '';
  @Output() save = new EventEmitter<void>();
  @Output() discard = new EventEmitter<void>();
  onSave(): void { if (this.dirty && !this.saving && !this.blocked) this.save.emit(); }
  onDiscard(): void { if (this.dirty && !this.saving && !this.blocked) this.discard.emit(); }
}
